import { render } from "./ProjectBimSmetaHandbook.vue?vue&type=template&id=775bf158&scoped=true"
import script from "./ProjectBimSmetaHandbook.vue?vue&type=script&lang=js"
export * from "./ProjectBimSmetaHandbook.vue?vue&type=script&lang=js"

import "./ProjectBimSmetaHandbook.vue?vue&type=style&index=0&id=775bf158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775bf158"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QBanner});
